import { useAuth } from '@neotech-solutions-org/neofusion-fe-shared';
import { AppBar, Toolbar } from '@mui/material';
import { memo, useCallback } from 'react';
import { useShellNavigationOptions } from '../../../../hooks/components/useShellNavigationOptions';
import useBreakpoints from '../../../../hooks/useBreakpoints';
import useShouldShowBetslip from '../../../../hooks/useShouldShowBetslip';
import { NEOBET_OPEN_BETSLIP_EVENT } from '../constants';
import { DesktopAuthenticatedToolbar, MobileAuthenticatedToolbar } from './AuthenticatedToolbars';
import { styles } from './Header.styles';
import MobileBetslipFab from './MobileBetslipFab';
import PublicToolbar from './PublicToolbar';

type HeaderProps = {
  isDrawerOpen?: boolean;
  isSidebarCompact?: boolean;
  showSidebarCollapse?: boolean;
  toggleDrawerVisibility?: (isOpen: boolean) => void;
  toggleSidebarCompact?: () => void;
};

const Header = memo(({ isSidebarCompact = false, showSidebarCollapse = false, toggleSidebarCompact }: HeaderProps) => {
  const openBetslip = useCallback(() => {
    window.dispatchEvent(new Event(NEOBET_OPEN_BETSLIP_EVENT));
  }, []);

  const { isAuthenticated } = useAuth();
  const { isMobile } = useBreakpoints();

  const { showSearchEntry } = useShellNavigationOptions();
  const showBetslip = useShouldShowBetslip();

  return (
    <>
      <AppBar position='fixed' elevation={0} sx={styles.appBar}>
        <Toolbar sx={styles.toolbar}>
          {!isAuthenticated ? (
            <PublicToolbar
              isMobile={isMobile}
              isSidebarCompact={isSidebarCompact}
              showSidebarCollapse={showSidebarCollapse}
              toggleSidebarCompact={toggleSidebarCompact}
            />
          ) : isMobile ? (
            <MobileAuthenticatedToolbar />
          ) : (
            <DesktopAuthenticatedToolbar
              isSidebarCompact={isSidebarCompact}
              showSidebarCollapse={showSidebarCollapse}
              showSearchEntry={showSearchEntry}
              toggleSidebarCompact={toggleSidebarCompact}
            />
          )}
        </Toolbar>
      </AppBar>

      {isMobile && showBetslip ? <MobileBetslipFab openBetslip={openBetslip} /> : null}
    </>
  );
});

export default Header;
